// extracted by mini-css-extract-plugin
export default {"first":"IconActive_first__zuq6P","second":"IconActive_second__4aYHG","third":"IconActive_third__2MOvX","fourth":"IconActive_fourth__EZMv0"};